module.exports = __webpack_public_path__ + "assets/06b1207a474f7b75167b2f14cd4d8f71.png";